module.exports = __webpack_public_path__ + "img/footer-bg.7c1b5945.png";